import React from "react";
import { IUserProfileFormProps } from "./use-profile-form.types";
import { StudentForm } from "./student-form";
import { ParentForm } from "./parent-form";
import { LoginStudentForm } from "./login-student-form";
import { LoginParentForm } from "./login-parent-form";
import { UserType } from "types/common/common.types";

const UserProfileForm = ({
  userType,
  packageId = "",
  tenureId = "",
  summaryPackageData,
  gradeFromPackageData
}: IUserProfileFormProps): JSX.Element => {
  if (userType === UserType.STUDENT && packageId && tenureId) {
    return (
      <StudentForm
        defaultGrade={gradeFromPackageData}
        userType={userType}
        summaryPackageData={summaryPackageData}
      />
    );
  } else if (userType === UserType.STUDENT && !packageId) {
    return <LoginStudentForm userType={userType} />;
  } else if (userType === UserType.PARENT && packageId && tenureId) {
    return (
      <ParentForm
        defaultGrade={gradeFromPackageData}
        userType={userType}
        summaryPackageData={summaryPackageData}
      />
    );
  } else {
    return <LoginParentForm userType={userType} />;
  }
};

export { UserProfileForm };
